import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { filter, map, Observable, of, take } from 'rxjs';
import { Store } from '@ngrx/store';
import * as userActions from '../../../shared/src/lib/store/actions/user.actions';
import { AppStateAi } from './ai.states';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class AiInitialDataResolver implements Resolve<any> {
    /**
     * Constructor
     */
    constructor(
        private store: Store<AppStateAi>,
        private translateService: TranslateService
    ) {
    }

    waitUser(): Observable<any> {
        return this.store.select("user").pipe(
            map(store => store),
            filter(store => store.loading === false),
            take(1)
        )
    }

    /**
     * Traductions prêtes. Déjà chargées : on répond tout de suite. Sinon on
     * attend leur chargement. Sans la vérification immédiate, une réponse de
     * `traductions/` arrivée avant le routeur laissait le lien candidat bloqué
     * sur l'écran de chargement (exploration e2e, 01/11/2026), comme le font
     * déjà les résolveurs student et examination.
     */
    waitTranslation(): Observable<any> {
        const currentLang = this.translateService.currentLang || this.translateService.defaultLang;
        const translations = this.translateService.translations[currentLang];
        if (translations && Object.keys(translations).length > 0) {
            return of(translations);
        }
        return this.translateService.onTranslationChange.pipe(
            filter(() => {
                const currentLang = this.translateService.currentLang;
                const translations = this.translateService.translations[currentLang];
                return translations && Object.keys(translations).length > 0;
            }),
            take(1)
        );
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Use this resolver to resolve initial mock-api for the application
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        return this.waitTranslation();
    }
}
